import {useCallback, useContext, useEffect, useMemo, useState} from 'react';

import {UserPasswordExpireSoonModal} from 'components';
import {UserContext} from 'context';
import {UserPasswordExpireStatus} from 'enums';
import {userAuthUtils} from 'utils';

export const UserPasswordChangeReminder: React.FC = () => {
    const {settings} = useContext(UserContext);
    const [remindDisplayed, setRemindDisplayed] = useState(false);
    const [userPasswordExpireSoonModalProps, setUserPasswordExpireSoonModalProps] = useState<{
        open: boolean
    }>({open: false});

    const passwordStatus = useMemo(() =>
        userAuthUtils.getUserPasswordExpireStatus(settings?.registration?.userPasswordExpiration, settings?.common?.timeZone), [settings]);

    const handlePasswordExpireSoonModalClose = useCallback(() => {
        setUserPasswordExpireSoonModalProps({open: false});
    }, []);

    useEffect(() => {
        if (!remindDisplayed && passwordStatus === UserPasswordExpireStatus.ExpireSoon) {
            setUserPasswordExpireSoonModalProps({open: true});
            setRemindDisplayed(true);
        }
    }, [passwordStatus, remindDisplayed]);

    return (
        <UserPasswordExpireSoonModal
            {...userPasswordExpireSoonModalProps}
            onClose={handlePasswordExpireSoonModalClose}
        />
    );
};